const type = 'advanced'
const path = '/advance/html-node/'
const name = 'server.js'

const conditions = [
  {
    option: 'frontend',
    type: 'different',
    value: 'react',
  },
  {
    parameter: 'buttons',
    type: 'not_includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, conditions }
